module.exports = __webpack_public_path__ + "static/media/bity.6697da2a.svg";